// Whenever a product/item is viewed
// https://support.karte.io/post/3SObAcXAvjn5S6kSQ4wuBZ

export default function karteViewItem(item: any, stock_status: boolean) {
  try {
    item.stock_status = stock_status;

    (window as any).tracker.track("view_item", item);
  } catch (e) {
	if (e instanceof Error) {
	    if ("tracker" in window) {
	      (window as any).tracker.track("_error", {
	        message: e.message
	      });
	    }
	}
  }
}
